module.exports = __webpack_public_path__ + "static/media/1.bb14b2bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80132/1.jpg
// module id = 749
// module chunks = 0